import React from 'react'
import { isCarouselWidgetType, widgetTypeOptionsForSite } from '../../constants/widgetTypes'
import { useWidgetSite } from '../../contexts/WidgetSiteContext'
import WidgetTypeIcon from './WidgetTypeIcon'
import { widgetTypeColorClass } from './widgetTypeColors'
import styles from './WidgetTypeSelector.module.scss'

interface WidgetTypeSelectorProps {
  value: string
  onChange: (code: string) => void
  disabled?: boolean
}

const WidgetTypeSelector: React.FC<WidgetTypeSelectorProps> = ({ value, onChange, disabled }) => {
  const { siteCode } = useWidgetSite()
  return (
  <div className={styles.cards}>
    {widgetTypeOptionsForSite(siteCode).map(wt => {
      // The single "Carousel" option stays active for any of the four carousel
      // widget_type values (its own code is only the default variant).
      const active = value === wt.code
        || (isCarouselWidgetType(wt.code) && isCarouselWidgetType(value))
      return (
      <button
        key={wt.code}
        type="button"
        className={`${styles.card} ${widgetTypeColorClass(wt.code)} ${active ? styles.cardActive : ''}`}
        onClick={() => onChange(wt.code)}
        disabled={disabled}
        title={wt.label}
      >
        <div className={styles.icon}>
          <WidgetTypeIcon code={wt.code} size={24} />
        </div>
        <div className={styles.label}>{wt.label}</div>
      </button>
      )
    })}
  </div>
  )
}

export default WidgetTypeSelector
